import { Injectable } from "@angular/core";
import { HttpClient, HttpEventType, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { apiLinks } from "../core/api-links/api-links";
import { AuthService } from "./auth.service";
import { ErrorHandlerService } from './error-handler.service';
import { Merchant } from '../core/model/merchant';

@Injectable({
  providedIn: 'root'
})
export class MyTicketsService {

  constructor(private handleError: ErrorHandlerService,
    private httpClient: HttpClient) { }


  updateAction(id,data): Observable<Merchant[]> {
    return this.httpClient.put<Merchant>(`${apiLinks.updateTicketActions}/${id}`,data).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError.handleError)
    );
  }

  addComments(id,data): Observable<Merchant[]> {
    return this.httpClient.post<Merchant>(`${apiLinks.addComments}/${id}`,data).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError.handleError)
    );
  }

  getComments(id,data): Observable<Merchant[]> {
    return this.httpClient.post<Merchant>(`${apiLinks.addComments}/${id}`,data).pipe(
      map((res: any) => {
        return res.data;
      }),
      catchError(this.handleError.handleError)
    );
  }

  updatehelpdeskEmails(data): Observable<Merchant[]> {
    return this.httpClient.put<Merchant>(`${apiLinks.updateHelpdeskEmails}`,data).pipe(
      map((res: any) => {
        return res.data;
      }),
      catchError(this.handleError.handleError)
    );
  }


}
